<h2 mat-dialog-title>Importe seu extrato em formato OFX</h2>

<button mat-icon-button type="button" class="dialog-close-button" (click)="dialogRef.close()">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <!-- Aviso de conta divergente -->
  @if (divergenteResponse) {
    <app-alert-card type="warning" title="O arquivo OFX pertence a uma conta diferente da selecionada">
      <p class="divergente-detail">
        <strong>No arquivo:</strong>
        Cód. Banco {{ divergenteResponse.bankIdOfx }} &bull; Conta {{ divergenteResponse.acctIdOfx }}
      </p>
      <p class="divergente-detail">
        <strong>Conta selecionada:</strong>
        {{ divergenteResponse.nomeBancoContaSelecionada }} &bull; Conta
        {{ divergenteResponse.numeroContaSelecionada }}
      </p>
      <p class="divergente-hint">Deseja importar mesmo assim?</p>
    </app-alert-card>
  } @else {
    <!-- Instruções -->
    <ol class="instructions-list">
      <li>
        Acesse o site do seu Banco e exporte o seu extrato para um arquivo
        <strong>OFX / Money 2000</strong> no período desejado.
      </li>
      <li>
        Após salvar o arquivo no seu computador, você poderá importar o extrato da sua conta corrente para
        dentro do sistema.
      </li>
    </ol>
    <!-- Zona de upload -->
    <div
      class="upload-zone"
      [class.drag-over]="isDragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="isDragOver = false"
      (drop)="onDrop($event)"
      (click)="fileInput.click()">
      <input #fileInput type="file" accept=".ofx" style="display: none" (change)="onFileSelected($event)" />
      @if (!selectedFile) {
        <mat-icon class="upload-icon material-symbols-outlined">cloud_upload</mat-icon>
        <p class="upload-hint">Ou arraste-o para este espaço</p>
        <button
          mat-stroked-button
          type="button"
          class="btn-secondary"
          (click)="$event.stopPropagation(); fileInput.click()">
          <mat-icon>attach_file</mat-icon> Escolha um arquivo
        </button>
      }
      @if (selectedFile) {
        <mat-icon class="upload-icon" style="color: #2e7d32">check_circle</mat-icon>
        <p class="upload-file-name">
          <strong>{{ selectedFile.name }}</strong>
        </p>
        <small class="upload-file-size">{{ (selectedFile.size / 1024).toFixed(1) }} KB</small>
        <button mat-button type="button" color="warn" (click)="removerArquivo($event)">Remover</button>
      }
    </div>
    <!-- Info badge -->
    <app-alert-card type="info">
      Suportamos arquivos .ofx gerados por qualquer instituição financeira brasileira.
    </app-alert-card>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Estado normal -->
  @if (!divergenteResponse) {
    <button mat-button mat-dialog-close [disabled]="isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="!selectedFile || isLoading" (click)="importar()">
      @if (isLoading) {
        <mat-spinner [diameter]="18"></mat-spinner>
      }
      @if (!isLoading) {
        <span>Importar Extrato</span>
      }
    </button>
  }

  <!-- Estado divergente -->
  @if (divergenteResponse) {
    <button mat-button (click)="cancelarDivergente()" [disabled]="isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="confirmarDivergente()" [disabled]="isLoading">
      @if (isLoading) {
        <mat-spinner [diameter]="18"></mat-spinner>
      }
      @if (!isLoading) {
        <span>Importar mesmo assim</span>
      }
      @if (isLoading) {
        <span>Importando...</span>
      }
    </button>
  }
</mat-dialog-actions>
